import React, { useEffect, useState } from "react";
import HeaderHome from "../headers/headerHome";
import Trombinoscope from "../components/Trombinoscope";
import AdhesionForm from "../components/AdhesionForm";
import Footer from "../components/Footer";
import * as API from "../services/API";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";

function Contact(){
    const [membersList, setMembersList] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    useEffect(() => {
                API.getTrombinoscopeRequest(
                    (response)=>{
                        setMembersList(response.data);
                    },
                    ()=>{
                    }
                    )
                },
                []
    );
    return (
    <>
        <HeaderHome />

        <div className="container py-5">
        <h2 className="text-center fw-bold mb-5">
            Trombinoscope
        </h2>

        {/* <button className="btn btn-primary mb-4">
            ➕ Ajouter un membre
        </button> */}

        <Trombinoscope members={membersList} />

        <hr className="my-5" />

        <AdhesionForm onSubmit={(data) => API.createAdhesionRequest(data,()=>{setSuccess("Demande envoyee avec succes.");},(err)=>{setError(err);})} />
        </div>
        <ErrorModal
            show={!!error}
            message={error}
            onClose={() => setError(null)}
        />
        <SuccessToast
            show={!!success}
            message={success}
            onClose={() => setSuccess(null)}
        />
        <Footer />
    </>
    );
}
export default Contact;
